import { UploadOutline } from '../../utils/editorReactIcons';
export { UploadOutline };
export default UploadOutline;
